//#region src/json/safe-parse.ts
/**
* Safely parses a JSON string and returns the resulting object or `undefined` if parsing fails.
* @template T - The expected type of the parsed object.
* @param {string} jsonString - The JSON string to parse.
* @returns {T | undefined} The parsed object if the JSON is valid, or `undefined` if an error occurs.
*/
const safeParseJSON = (jsonString) => {
	try {
		return JSON.parse(jsonString);
	} catch {
		return;
	}
};

//#endregion
export { safeParseJSON };